export default __webpack_public_path__ + "static/vivimos-la-265e5c912e02586388588c4313e786e4.png";